var _path;
import * as React from "react";
var SvgShareFacebook = function SvgShareFacebook(props) {
  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-4,-2)",
    d: "M12.060696,7.820572c0,0.670626,0,3.663913,0,3.663913H9.376396v4.480247h2.684299v13.313782 h5.514122V15.965104h3.700294c0,0,0.346542-2.148244,0.514462-4.497138c-0.481607,0-4.193905,0-4.193905,0s0-2.606466,0-3.063326 c0-0.45785,0.601208-1.07372,1.195423-1.07372c0.5931,0,1.844887,0,3.00436,0c0-0.609992,0-2.717649,0-4.664192 c-1.547842,0-3.308708,0-4.084826,0C11.924393,2.666419,12.060696,7.151122,12.060696,7.820572z"
  }));
};
export default SvgShareFacebook;